<template>
    <div v-if="json">
        <DxDiagram id="diagram" ref="diagram" :simple-view="true" :read-only="true" @item-click="itemClick">
            <DxViewToolbar :visible="false" />
        </DxDiagram>
    </div>
    <div v-else>
        <div style="line-height:470px; text-align:center;">暂无数据</div>
    </div>
</template>

<script>
/* eslint-disable */
import { DxDiagram, DxViewToolbar } from "devextreme-vue/diagram";
import EventBus from "../js/event-bus";

export default {
    name: "EnterpriseFlowChart",
    components: {
        DxDiagram,
        DxViewToolbar,
    },
    data() {
        return {
            json: null,
            diagram: null,
        };
    },
    mounted() {
        EventBus.$on(
            "changeFlowChart",
            (organizationId, hwCode2, type, alias) => {
                if (!organizationId || !hwCode2 || !type) {
                    this.json = null;
                    return;
                }
                this.getFlowChartByHwCode(organizationId, hwCode2, type, alias);
            }
        );
    },
    methods: {
        getFlowChartByHwCode(organizationId, hwCode2, type, alias) {
            this.json = null;
            this.$api
                .getFlowChartByHwCode(organizationId, hwCode2, type, alias)
                .then((result) => {
                    if (result.ok === true && result.data) {
                        this.json = result.data.content;
                        setTimeout(() => {
                            this.importContentJson();
                        }, 100);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        importContentJson() {
            this.diagram = this.$refs["diagram"].instance;
            this.diagram.import(this.json);
        },
        itemClick(e) {
            console.log(e);
        },
    },
};
</script>
<style lang="less">
#diagram {
    height: 470px;
    border: none;
}
.dxdi-canvas .page {
    fill: #131654 !important;
}
</style>
